import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import ptBR from './locales/pt-BR.json'
import { pnaAnaEn, pnaAnaPtBR } from './pnaAna'

export type AppLanguage = 'pt-BR' | 'en'
export const LANGUAGE_STORAGE_KEY = 'icpm.language'

function initialLanguage(): AppLanguage {
  const query = new URLSearchParams(window.location.search).get('lang')
  if (query === 'en') return 'en'
  if (query === 'pt-BR' || query === 'pt') return 'pt-BR'
  return window.localStorage.getItem(LANGUAGE_STORAGE_KEY) === 'en' ? 'en' : 'pt-BR'
}

void i18n.use(initReactI18next).init({
  resources: {
    'pt-BR': { translation: { ...ptBR, pnaAna: pnaAnaPtBR } },
    en: { translation: { ...en, pnaAna: pnaAnaEn } },
  },
  lng: initialLanguage(),
  fallbackLng: 'pt-BR',
  supportedLngs: ['pt-BR', 'en'],
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
})

export function appLanguage(): AppLanguage {
  return i18n.resolvedLanguage === 'en' ? 'en' : 'pt-BR'
}

export function appLocale(): string {
  return appLanguage() === 'en' ? 'en-US' : 'pt-BR'
}

export async function changeAppLanguage(language: AppLanguage): Promise<void> {
  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language)
  await i18n.changeLanguage(language)
}

export default i18n
